'use client';

import { BudgetAlertBanner } from '@/components/admin/budget-alert-banner';

export function Header() {
  return <BudgetAlertBanner />;
}
